/** `tab=` start parameters of Telegram Ads and broadcast links, and the onboarding page each one opens. */
export const AD_ONBOARDING_TABS = {
  grid: "ad-grid",
  business: "ad-business"
} as const

export const AD_ONBOARDING_PATHS = {
  grid: "/welcome/grid",
  business: "/celestia-pro/business-mode/start"
} as const

export type AdOnboardingTab = (typeof AD_ONBOARDING_TABS)[keyof typeof AD_ONBOARDING_TABS]

export const isAdOnboardingTab = (value: string | null | undefined): value is AdOnboardingTab =>
  value === AD_ONBOARDING_TABS.grid || value === AD_ONBOARDING_TABS.business
